exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-blog-post-template-js": () => import("./../../../src/templates/BlogPost.template.js" /* webpackChunkName: "component---src-templates-blog-post-template-js" */),
  "component---src-templates-portfolio-post-template-js": () => import("./../../../src/templates/PortfolioPost.template.js" /* webpackChunkName: "component---src-templates-portfolio-post-template-js" */)
}

